import { Lightning, Router } from '@lightningjs/sdk'

import Button from '../components/button/button'
import { getColor, grey300, grey50, grey960 } from '../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../constants/fonts'
import { Images } from '../constants/paths'
import { getText } from '../utils/dictionary'
import { getAsset } from '../utils/image'
import { generateQR } from '../utils/misc'
import PageHandler from './handlers/pageHandler'

export default class LgSignUp extends PageHandler {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(grey960),
      flex: { direction: 'column' },
      Header: {
        w: (w) => w,
        h: 192,
        Logo: {
          x: 85,
          y: 81.16,
          h: 47.7,
          w: 420,
          texture: Lightning.Tools.getSvgTexture(getAsset(Images.LOGO_LARGE), 420, 47.7),
        },
      },
      Container: {
        w: (w) => w,
        h: 888,
        flex: { direction: 'row' },
        texture: Lightning.Tools.getSvgTexture(
          getAsset(Images.LOGIN_WITH_SMARTPHONE_BG),
          1920,
          888,
        ),
        TextBlock: {
          w: (w) => w / 2,
          h: (h) => h,
          flex: {
            direction: 'column',
            justifyContent: 'center',
            paddingLeft: 164,
          },
          Title: {
            text: {
              text: getText('signUp'),
              textColor: getColor(grey50),
              fontSize: 64,
              fontFace: UniNeueBold,
            },
          },
          Subtitle: {
            text: {
              text: getText('lgSignUpMessage'),
              textColor: getColor(grey300),
              fontSize: 32,
              fontFace: UniNeueRegular,
            },
          },
          Button: {
            w: 240,
            type: Button,
            icon: 'icon-back-arrow',
            label: getText('goBackButton'),
            flexItem: { marginTop: 40 },
          },
        },
        QrBlock: {
          w: (w) => w / 2,
          h: (h) => h,
          flex: {
            direction: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          },
          QrCode: {
            w: 497,
            h: 497,
            rect: true,
            color: getColor(grey50),
            src: '',
            flexItem: { marginBottom: 16 },
          },
          QrText: {
            text: {
              text: getText('lgSignUpQrCodeText'),
              textColor: getColor(grey300),
              fontSize: 28,
              fontFace: UniNeueRegular,
              advancedRenderer: true,
            },
          },
        },
      },
    }
  }

  get button() {
    return this.tag('Button') as Button
  }

  get qrCode() {
    return this.tag('QrCode')
  }

  _getFocused() {
    return this.button
  }

  _handleEnter() {
    Router.back()
  }

  _handleClick() {
    this._handleEnter()
  }

  _onCursorLeave() {
    this.button?._focus()
  }

  async _active() {
    this.setLoadingAnimation(true)

    await this.setQR(getText('lgSignUpQrUrl'))

    this.setLoadingAnimation(false)
  }

  async setQR(textToQr: string) {
    this.qrCode.patch({
      src: await generateQR(textToQr, {
        margin: 1,
        color: { dark: '#ffffff', light: '#00000000' },
        width: 460,
      }),
    })
  }
}
